import React from 'react';
import { Field, getFormValues, isDirty, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import DropdownSelect from 'components/Fields/ReduxForm/DropdownSelect';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import {
  onChangeKeyword,
  onChangeStatus,
  onClickCreatePromo,
} from 'actions/businessLibrary/promo/promo';
import { askConfirmAction } from 'actions/confirm-action';
import * as _ from 'lodash';
import MenuTitle from 'components/MenuTitle';
import styles from './ActionBar.css';

const PROMO_STATUS = [
  { name: 'All Status', id: null },
  { name: 'Scheduled', id: 'scheduled' },
  { name: 'Ongoing', id: 'ongoing' },
  { name: 'Inactive', id: 'inactive' },
];

class ActionBar extends React.Component {
  render() {
    return (
      <div>
        <MenuTitle menuTitle="Promo" />
        <div className="col-sm-5 col-md-6 action-promo">
          <span className={styles['create-btn']}>
            <button
              className="btn btn-primary"
              onClick={this._clickCreatePromo}
            >
              Create Promo
            </button>
          </span>
        </div>
        <div className={styles.wrapper}>
          <div className="row">
            <div className={`col-sm-12 col-xs-12 ${styles['action-bar']}`}>
              <div className={`col-sm-12 ${styles.type}`}>
                <div className="filter-promo-status">
                  <Field
                    name="promoStatus"
                    component={DropdownSelect}
                    options={PROMO_STATUS}
                    className="dropdown-select-inventories"
                    onChange={e => {
                      this._onChangePromoStatus(e);
                    }}
                  />
                </div>
                <div className="search-promo">
                  <Field
                    name="search"
                    component={SearchBar}
                    placeholder="Search promo"
                    onChange={e => {
                      this._onChangeKeyword(e);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _clickCreatePromo = () => {
    const { dispatch, outlets, isDirtyPromoTypeAndName } = this.props;
    if (!isDirtyPromoTypeAndName) {
      dispatch(onClickCreatePromo(outlets));
    } else {
      dispatch(askConfirmAction(onClickCreatePromo(outlets)));
    }
  };

  _onChangePromoStatus = e => {
    const { searchValues, hashedOutlets } = this.props;
    const promoId =
      (searchValues && parseInt(searchValues.promoType) === 0) ||
      isNaN(searchValues.promoType)
        ? null
        : parseInt(searchValues.promoType);
    const status = e.target.value === 'All Status' ? null : e.target.value;
    const keyword =
      searchValues && searchValues.search ? searchValues.search.trim() : null;
    this.props.dispatch(
      onChangeStatus(promoId, status, keyword, hashedOutlets)
    );
  };

  _onChangeKeyword = e => {
    const { searchValues, hashedOutlets } = this.props;
    const promoId =
      (searchValues &&
        searchValues.promoType &&
        parseInt(searchValues.promoType) === 0) ||
      isNaN(searchValues.promoType)
        ? null
        : parseInt(searchValues.promoType);
    const status =
      (searchValues && parseInt(searchValues.promoStatus) === 0) ||
      searchValues.promoStatus === 'All Status'
        ? null
        : searchValues.promoStatus;
    const keyword = e.target.value === '' ? null : e.target.value.trim();
    this.props.dispatch(
      onChangeKeyword(promoId, status, keyword, hashedOutlets)
    );
  };
}

const mapForm = {
  form: 'search',
};

function mapStateToProps(state) {
  const { outlets, currentPage } = state.businessLibrary.promo;
  const hashedOutlets = _.mapKeys(outlets, 'id');

  return {
    outlets,
    isDirtyPromoTypeAndName: isDirty('promoTypeAndName')(state),
    searchValues: getFormValues('search')(state),
    currentPage,
    hashedOutlets,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(ActionBar));
